import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { apiCall } from "services/api";

import { NotificationParams } from "./types";

export const getAllNotifications = createAsyncThunk(
  "/notifications",
  async (params: NotificationParams, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/notifications", {
        params: { ...params },
      });
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUnreadNotifications = createAsyncThunk(
  "/notifications/unread",
  async (params: NotificationParams, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/notifications/unread", { params });
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const readNotification = createAsyncThunk(
  "/notifications/read/:id",
  async (notificationId: string, { rejectWithValue }) => {
    try {
      const response = await apiCall().put(
        `/notifications/read/${notificationId}`
      );
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const readAllNotifications = createAsyncThunk(
  "/notifications/read-all",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().post(`/notifications/read-all`);
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
